import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = (props: any) => {
  const token = useSelector((state: any) => state?.auth?.token);
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
